import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from '../service/http.service';
import { SchoolInvoiceWithPaymentOrders } from '../school-invoice-with-payment-orders';
import { BookingTransactionsService } from '../service/booking-transactions.service';
import { ToastMessageService } from '../toast-message.service';
import { SchoolInvoice } from '../school-invoice';

@Component({
  selector: 'app-edit-school-invoice-file',
  templateUrl: './edit-school-invoice-file.component.html',
  styleUrls: ['./edit-school-invoice-file.component.css']
})
export class EditSchoolInvoiceFileComponent implements OnInit {

  @Input() schoolInvoice!: SchoolInvoice;

  constructor(
    private httpService: HttpService,
    private toastService: ToastMessageService,
    private bookingTransactionsService: BookingTransactionsService
  ) { }

  ngOnInit(): void {
  }

  uploadSchoolInvoiceFile(files: File[], form: any){
    if (files.length == 0) {
      return;
    }
    if(this.schoolInvoice.fileId == null){
      this.httpService.postSchoolInvoiceFile(this.schoolInvoice.id!, files[0]).subscribe(res => {
        this.toastService.addSuccess("Success", "File uploaded");
        form.clear();
        this.schoolInvoice.fileName = files[0].name;
        this.schoolInvoice.fileId = res;
        this.bookingTransactionsService.creatingSchoolInvoiceFile = false;
      }, error => this.toastService.addError("Error", error.error.message));
    } else {
      this.httpService.updateSchoolInvoiceFile(this.schoolInvoice.fileId, files[0]).subscribe(res => {
        this.toastService.addSuccess("Success", "File updated");
        form.clear();
        this.schoolInvoice.fileName = files[0].name;
        this.bookingTransactionsService.creatingSchoolInvoiceFile = false;
      }, error => this.toastService.addError("Error", error.error.message));
    }
  }

  

}
